import { setAlert } from "../alert";
import { handleError } from "../error";
import { SET_APP_ROUTE } from "../../types";

export const copyToClipboard = event => async dispatch => {
    try {
        const { classList } = event.target;

        if (classList.contains("copy-address")) {
            let address = document.querySelector('[name="full-asset-address"]');
            address.select();
            /* Copy the text inside the text field */
            try {
                document.execCommand("copy");
            }
            catch (error) {
                dispatch(setAlert(error.message, "warning"));
            }
            /* Alert the copied text */
            dispatch(setAlert("Address is copied to clipboard.", "info"));
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, "warning"));
    }
};

export const setRoute = routeProps => async dispatch => {
    try {
        await dispatch({
            type: SET_APP_ROUTE,
            payload: routeProps
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};